import { API_CONFIG } from "../../shared/api/config";

const BASE_URL = API_CONFIG.API_BASE_PATH;

export const API_URLS = {
    labelerTemplatesUrl: BASE_URL + 'labeler/templates/',
    labelerZPLPreviewUrl: BASE_URL + 'labeler/templates/preview/' ,
    labelerSummaryDataUrl: BASE_URL + 'labeler/templates/summary/',
    literTaxUUIDUrl: BASE_URL + 'labeler/liter-tax-uuid/'
}